import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    OutlinedInput,
    Select,
    MenuItem,
    Modal,
    Typography,
    Tooltip,
    IconButton
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { apiCreateForward } from '@store';
import { showToast } from '@utils';
import {
    delivery_period_options,
    months_options,
    price_type_options,
    years_options
} from '../../../data';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import UploadFileModal from './UploadFileModal';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const Forward = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state?.user);
    const { allUsers } = useSelector((state) => state?.user);
    const { portfolio } = useSelector((state) => state?.portfolio);
    const { counterParty } = useSelector((state) => state?.counterParty);
    const { brokers } = useSelector((state) => state?.broker);
    // const { endpoints } = useSelector((state) => state?.endpoints);
    const { exchanges } = useSelector((state) => state?.exchanges);

    const initialState = {
        instrument_type: 'forward',
        transaction_type: '',
        trade_type: '',
        trader: '',
        portfolio: '',
        counterparty: '',
        reference: '',
        trade_date: '',
        settlement_time: '',
        payment_date: '',
        accounting_date: '',
        exchange: '',
        broker: '',
        status: '',
        comments: '',
        price_type: '',
        endpoint: '',
        payment_frequency: 'Monthly',
        delivery_period_sym: '',
        delivery_period_month: '',
        delivery_period_year: '',
        start_date: '',
        end_date: '',
        currency: '',
        price: '',
        volume: '',
        capacity: ''
    };

    const [state, setState] = useState(initialState);

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const handleDateChange = (name, value) => {
        setState({
            ...state,
            [name]: value ? value.format('YYYY-MM-DD') : ''
        });
    };

    const [openModal, setOpenModal] = useState(false);

    const handleUploadFile = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        data.trade_date = new Date(data?.trade_date).toISOString();
        data.start_date =
            data?.start_date === ''
                ? ''
                : new Date(data?.start_date).toISOString();
        data.end_date =
            data?.end_date === '' ? '' : new Date(data?.end_date).toISOString();
        data.price = parseInt(data?.price);
        data.capacity = parseInt(data?.capacity);
        data.volume = parseInt(data?.volume);
        data.delivery_period_year = parseInt(data?.delivery_period_year);

        for (const key in data) {
            if (
                data[key] === '' ||
                data[key] === null ||
                data[key] === undefined
            ) {
                delete data[key];
            }
        }

        const response = await dispatch(apiCreateForward(data));
        if (response.meta.requestStatus === 'fulfilled') {
            showToast('success', 'Forward created successfully');
            setState(initialState);
        } else if (response.meta.requestStatus === 'rejected') {
            showToast('error', response.payload);
        }
    };

    const handleClear = () => {
        setState(initialState);
    };

    return (
        <>
            <Modal open={openModal} onClose={handleCloseModal}>
                <UploadFileModal handleClose={handleCloseModal} />
            </Modal>
            <Box className="border bg-white h-full">
                <Box className="px-8 py-4 border-b-2 flex justify-between items-center">
                    <Typography fontSize={'large'}>
                        Create New Forward
                    </Typography>
                    <Tooltip title="Upload File">
                        <IconButton onClick={handleUploadFile}>
                            <UploadOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Box className="px-8 py-4">
                    <Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Transaction Type
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select22"
                                    label="Transaction Type"
                                    name="transaction_type"
                                    value={state?.transaction_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value={'buy'}>Buy</MenuItem>
                                    <MenuItem value={'sell'}>Sell</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Trade Type
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Trade Type"
                                    name="trade_type"
                                    value={state?.trade_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value={'Physical'}>
                                        Physical
                                    </MenuItem>
                                    <MenuItem value={'Financial'}>
                                        Financial
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Trader
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Trader"
                                    name="trader"
                                    value={state?.trader}
                                    onChange={handleChange}
                                >
                                    {allUsers?.map((user, index) => (
                                        <MenuItem key={index} value={user}>
                                            {user.fullname}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Portfolio
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Portfolio"
                                    name="portfolio"
                                    value={state?.portfolio}
                                    onChange={handleChange}
                                    required
                                >
                                    {portfolio?.map((pf, index) => (
                                        <MenuItem key={index} value={pf}>
                                            {pf.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Counterparty
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Counterparty"
                                    name="counterparty"
                                    value={state?.counterparty}
                                    onChange={handleChange}
                                >
                                    {counterParty?.map((cp, index) => (
                                        <MenuItem key={index} value={cp}>
                                            {cp.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth={true}>
                                <InputLabel id="referenceLabel">
                                    Reference
                                </InputLabel>
                                <OutlinedInput
                                    id="reference"
                                    label="Reference"
                                    name="reference"
                                    value={state?.reference}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <FormControl fullWidth>
                                    <DatePicker
                                        label="Trade Date"
                                        format="DD/MM/YYYY"
                                        value={
                                            state?.trade_date
                                                ? dayjs(state?.trade_date)
                                                : null
                                        }
                                        onChange={(value) =>
                                            handleDateChange(
                                                'trade_date',
                                                value
                                            )
                                        }
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                placeholder: 'DD/MM/YYYY'
                                                // required: true
                                            }
                                        }}
                                    />
                                </FormControl>
                            </LocalizationProvider>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Exchange
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Exchange"
                                    name="exchange"
                                    value={state?.exchange}
                                    onChange={handleChange}
                                >
                                    {exchanges?.map((exchange, index) => (
                                        <MenuItem key={index} value={exchange}>
                                            {exchange.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Broker
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Broker"
                                    name="broker"
                                    value={state?.broker}
                                    onChange={handleChange}
                                >
                                    {brokers?.map((broker, index) => (
                                        <MenuItem key={index} value={broker}>
                                            {broker.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Status
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Status"
                                    name="status"
                                    value={state?.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value={'New'}>New</MenuItem>
                                    <MenuItem value={'Pending'}>
                                        Pending
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box marginBottom={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <InputLabel
                                    id="commentLabel"
                                    sx={{ bgcolor: '#FFFFFF' }}
                                >
                                    Comments and Conditions
                                </InputLabel>
                                <OutlinedInput
                                    id="comments"
                                    label="Comments"
                                    name="comments"
                                    value={state?.comments}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Price Type
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Price Type"
                                    name="price_type"
                                    value={state?.price_type}
                                    onChange={handleChange}
                                    required
                                >
                                    {price_type_options?.map(
                                        (option, index) => (
                                            <MenuItem
                                                key={index}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        )
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Endpoint
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Endpoint"
                                    name="endpoint"
                                    value={state?.endpoint}
                                    onChange={handleChange}
                                >
                                    {user?.Endpoints?.map((endpoint, index) => (
                                        <MenuItem key={index} value={endpoint}>
                                            {endpoint.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel shrink htmlFor="payment-frequency">
                                    Payment Frequency
                                </InputLabel>
                                <OutlinedInput
                                    id="payment-frequency"
                                    notched
                                    label="Payment Frequency"
                                    value="Monthly"
                                    inputProps={{ readOnly: true }}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Currency
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Currency"
                                    name="currency"
                                    value={state?.currency}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value={'EUR'}>EUR</MenuItem>
                                    <MenuItem value={'CHF'}>CHF</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth>
                                <InputLabel
                                    id="demo-simple-select-label"
                                    sx={{ bgcolor: '#FFFFFF', pr: 1 }}
                                >
                                    Delivery Period
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Delivery Period"
                                    name="delivery_period_sym"
                                    value={state?.delivery_period_sym}
                                    onChange={handleChange}
                                    required
                                >
                                    {delivery_period_options?.map(
                                        (option, index) => (
                                            <MenuItem
                                                key={index}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        )
                                    )}
                                </Select>
                            </FormControl>
                            {state?.delivery_period_sym === 'DA' ||
                            state?.delivery_period_sym === 'BOM' ||
                            state?.delivery_period_sym === 'MANUAL' ? (
                                <FormControl fullWidth>
                                    <InputLabel
                                        htmlFor="start_date"
                                        shrink
                                        sx={{ bgcolor: '#F5F5F5' }}
                                    >
                                        Start Date
                                    </InputLabel>
                                    <OutlinedInput
                                        id="start_date"
                                        type="date"
                                        value={state?.start_date}
                                        onChange={handleChange}
                                        name="start_date"
                                        required
                                    />
                                </FormControl>
                            ) : null}
                            {state?.delivery_period_sym === 'MANUAL' && (
                                <FormControl fullWidth>
                                    <InputLabel
                                        htmlFor="end_date"
                                        shrink
                                        sx={{ bgcolor: '#F5F5F5' }}
                                    >
                                        End Date
                                    </InputLabel>
                                    <OutlinedInput
                                        id="end_date"
                                        type="date"
                                        value={state?.end_date}
                                        onChange={handleChange}
                                        name="end_date"
                                        required
                                    />
                                </FormControl>
                            )}
                            {state?.delivery_period_sym === 'MONTH' ||
                            state?.delivery_period_sym === 'SUMMER' ||
                            state?.delivery_period_sym === 'WINTER' ||
                            state?.delivery_period_sym === 'Q1' ||
                            state?.delivery_period_sym === 'Q2' ||
                            state?.delivery_period_sym === 'Q3' ||
                            state?.delivery_period_sym === 'Q4' ||
                            state?.delivery_period_sym === 'CAL' ||
                            state?.delivery_period_sym === 'GY' ? (
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Year
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Month"
                                        name="delivery_period_year"
                                        value={state?.delivery_period_year}
                                        onChange={handleChange}
                                        required
                                    >
                                        {years_options?.map((option, index) => (
                                            <MenuItem
                                                key={index}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            ) : null}
                            {state?.delivery_period_sym === 'MONTH' ? (
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Month
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Month"
                                        name="delivery_period_month"
                                        value={state?.delivery_period_month}
                                        onChange={handleChange}
                                        required
                                    >
                                        {months_options?.map(
                                            (option, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            ) : null}
                        </Box>
                        <Box className="flex gap-3" marginBottom={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <InputLabel
                                    id="capacityLabel"
                                    sx={{
                                        bgcolor: '#FFFFFF',
                                        p: '0px 2px 0px'
                                    }}
                                >
                                    Capacity (MW)
                                </InputLabel>
                                <OutlinedInput
                                    id="capacity"
                                    label="Capacity"
                                    type="number"
                                    onKeyDown={(e) =>
                                        e.key === 'e' && e.preventDefault()
                                    }
                                    name="capacity"
                                    value={state?.capacity}
                                    onChange={handleChange}
                                    disabled={state?.volume !== ''}
                                    inputProps={{ min: 0, step: 'any' }}
                                />
                            </FormControl>
                            <FormControl fullWidth={true} variant="outlined">
                                <InputLabel
                                    id="volumeLabel"
                                    sx={{ bgcolor: '#FFFFFF' }}
                                >
                                    Volume (MWh)
                                </InputLabel>
                                <OutlinedInput
                                    id="volume"
                                    label="Volume (MWh)"
                                    type="number"
                                    name="volume"
                                    onKeyDown={(e) =>
                                        e.key === 'e' && e.preventDefault()
                                    }
                                    value={state?.volume}
                                    onChange={handleChange}
                                    disabled={state?.capacity !== ''}
                                    inputProps={{ min: 0, step: 'any' }}
                                />
                            </FormControl>
                        </Box>
                        <FormControl fullWidth={true} variant="outlined">
                            <InputLabel
                                id="priceLabel"
                                sx={{ bgcolor: '#FFFFFF' }}
                            >
                                Price
                            </InputLabel>
                            <OutlinedInput
                                id="price"
                                label="Price"
                                type="number"
                                name="price"
                                onKeyDown={(e) =>
                                    e.key === 'e' && e.preventDefault()
                                }
                                value={state?.price}
                                onChange={handleChange}
                                inputProps={{ min: 0, step: 'any' }}
                            />
                        </FormControl>
                    </Box>
                    <Box className="flex justify-end mt-2 gap-3">
                        <Button
                            variant="outlined"
                            color="error"
                            sx={{
                                borderColor: '1px solid #EB6969',
                                color: '#EB6969',
                                fontSize: '14px',
                                '&:hover': {
                                    borderColor: '1px solid #EB6969',
                                    color: 'white',
                                    backgroundColor: '#EB6969'
                                }
                            }}
                            onClick={handleClear}
                        >
                            Clear
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            type="submit"
                            variant="contained"
                            className="page-button"
                            sx={{
                                bgcolor: '#0b9cfd',
                                '&:hover': {
                                    bgcolor: '#0b9cfd'
                                }
                            }}
                            disabled={
                                state?.volume === '' && state?.capacity === ''
                            }
                        >
                            Submit
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default Forward;
